import React, { Component } from "react";
import { connect } from "react-redux";
import { compose } from "redux";
import {
    addFolder,
    addFolderAndAdvertiserSaga,
    addFolderSaga,
    editFolder,
    editFolderSaga,
    getFolderEditing,
    getFolders,
    getModalState,
    toggleFolderModal
} from "state/modules/app/folder";
import CreateFolder from "../../components/Modal/CreateFolder";
import { MuiThemeProvider } from "@material-ui/core/styles";
import customMaterialUi from "../../materialUITheme";


@connect(
    (state) => ({
        editingFolder: getFolderEditing(state),
        folders: getFolders(state),
        modalOpen: getModalState(state)
    }),
    dispatch => ({
        addFolder: compose(dispatch, addFolder),
        addFolderSaga: compose(dispatch, addFolderSaga),
        addFolderAndAdvertiserSaga: compose(dispatch, addFolderAndAdvertiserSaga),
        editFolderSaga: compose(dispatch, editFolderSaga),
        editFolder: compose(dispatch, editFolder),
        toggleFolderModal: compose(dispatch, toggleFolderModal)
    })
)

class FolderDialog extends Component {
    onClose = () => {
        this.props.toggleFolderModal(false);
    };

    render() {
        return (
            <MuiThemeProvider theme={customMaterialUi}>
                <CreateFolder
                    onClose={this.onClose}
                    {...this.props}
                />
            </MuiThemeProvider>

        );
    }
}

export default FolderDialog;
